import { api } from 'data/api/api'
import { GetReturnShippingOptionsResp } from 'types/api/response/get-return-shipping-options-resp'

export const getReturnShippingOptions = (transactionId: number) =>
  api.get<GetReturnShippingOptionsResp>(
    `/transactions/${transactionId}/shipment/return_shipping_options`,
  )
